<template>
  <div class="class-tournaments">
    <b-loading :is-full-page="false" v-model="isLoading"></b-loading>

    <div v-if="currentClass">
      <p class="is-size-5 has-text-centered">
        {{ currentClass.schoolName }} - {{ currentClass.groupName }}
      </p>
      <section
        class="is-flex is-justify-content-space-between is-align-items-center pt-2"
      >
        <b-field class="my-0">
          <b-input
            v-model="filterText"
            placeholder="Type to search for tournaments ..."
            type="search"
            icon="search"
          ></b-input>
        </b-field>
      </section>

      <div class="is-flex mt-4">
        <CreateOfflineClassTournament
          :current-class="currentClass"
          button-icon="plus"
          @tournament-created="onTournamentCreated"
          @tournament-error="onTournamentError"
        />
      </div>

      <div class="mt-2">
        <ClassTournamentTable
          :tournaments="tournaments"
          @onDelete="deleteTournament"
        />
      </div>
    </div>
    <div v-else>Please select a class</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { firestore } from "@/services/firebase";
import ClassTournamentTable from "@/components/admins/tournaments/offline/ClassTournamentTable.vue";
import CreateOfflineClassTournament from "@/components/shared/CreateOfflineClassTournament.vue";
import ClassTournamentService from "@/services/ClassTournamentService";

export default {
  name: "OfflineClassTournaments",

  components: {
    ClassTournamentTable,
    CreateOfflineClassTournament,
  },

  data() {
    return {
      isLoading: false,
      tournaments: null,
      filterText: null,
    };
  },

  watch: {
    currentClass: {
      deep: true,
      immediate: true,
      handler() {
        if (!this.currentClass) {
          return;
        }

        const classTournamentsRef = firestore
          .collection("classTournaments")
          .where("classId", "==", this.currentClass.classId)
          .where("deletedAt", "==", null);
        this.$bind("tournaments", classTournamentsRef);
      },
    },
  },

  computed: {
    ...mapGetters({
      currentClass: "getCurrentClass",
    }),
  },

  methods: {
    /**
     * Handle successful tournament creation
     */
    onTournamentCreated(tournamentId) {
      console.log("Tournament created successfully:", tournamentId);
      // The shared component already shows success toast
    },

    /**
     * Handle tournament creation error
     */
    onTournamentError(error) {
      console.error("Tournament creation failed:", error);
      // Error handling is already done in the shared component
    },

    async deleteTournament(tournament) {
      this.isLoading = true;
      try {
        await ClassTournamentService.deleteTournament(tournament.id);
        this.$buefy.toast.open({
          message: "Tournament deleted!",
          type: "is-success",
        });
      } catch (error) {
        console.error("Error deleting tournament:", error);
        this.$buefy.toast.open({
          message: `Failed to delete tournament: ${error.message}`,
          type: "is-danger",
          duration: 5000,
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.class-tournaments {
  text-align: left;
}

.teacher-class-tournament__header {
  margin-bottom: 2rem;
}

.teacher-class-tournament__title {
  font-size: 1.5rem;
  font-weight: bold;
}

.teacher-class-tournament__content {
  margin-bottom: 2rem;
}
</style>
